// extracted by mini-css-extract-plugin
module.exports = {"multi_3_spec":"Multi3Spec_multi_3_spec__h8MWv"};